import { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [baseContainerConfig, setBaseContainerConfig] = useState({
    heading: '',
    subHeading: '',
    buttonText: '',
    buttonURL: '',
    buttonCallback: null,
    rightButtonExtraComponents: null,
    showFooter: true,
  });
  const [profile, setProfile] = useState({ loggedIn: false });
  const [admin, setAdmin] = useState({});

  return (
    <AppContext.Provider
      value={{ baseContainerConfig, setBaseContainerConfig, profile, setProfile, admin, setAdmin }}>
      {children}
    </AppContext.Provider>
  );
};
